"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _articleListing = _interopRequireDefault(require("../styles/article-listing.css"));
var _articleListing2 = _interopRequireDefault(require("./article-listing.props/article-listing.defaultProps"));
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString;
var shouldFormatDate = function shouldFormatDate(date, region) {
  var formatedDate = new Date(parseInt(date));
  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  var formatedRegion = region.toLowerCase();
  var fullDate = formatedDate.toLocaleDateString(formatedRegion, options);
  if (region === ' ' || fullDate === 'Invalid Date') {
    return ' ';
  }
  return fullDate;
};
var DateLabel = function DateLabel(_ref) {
  var date = _ref.date,
    time = _ref.time,
    config = _ref.config,
    theme = _ref.theme,
    isNewLayoutEnabled = _ref.isNewLayoutEnabled;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: _articleListing["default"].date + " " + theme.labelMedium
  }, shouldFormatDate(date, renderEmptyString(config.localeCode)), isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, time && date && /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _articleListing["default"].circularDot
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _articleListing["default"].date + " " + theme.labelMedium
  }, time)));
};
DateLabel.displayName = 'DateLabel';
DateLabel.defaultProps = {
  date: _articleListing2["default"],
  time: _articleListing2["default"],
  config: {},
  theme: {}
};
var _default = DateLabel;
exports["default"] = _default;